import React from "react";
import { useField } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { useStyles } from "styles/StyleDashboard";
import PropTypes from "prop-types";

const CustomSelect = ({ label, ...props }) => {
  const classes = useStyles();
  const [field, meta] = useField(props);
  return (
    <>
      <FormControl className={classes.formControlSeven}>
        <InputLabel required={true} className={classes.labelRoot} id="id-label">
          {label}
        </InputLabel>
        <Select {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className={classes.error}>{meta.error}</div>
        ) : null}
      </FormControl>
    </>
  );
};
CustomSelect.propTypes = {
  label: PropTypes.string,
  props: PropTypes.any
};
export default CustomSelect;
